/* سدر الخليج (STR-156): سلاسة التنقل واللمس.
   ملف مستقل لا يعدّل سكربت القالب: يستعمل واجهة أدراج Impact (hide) وعنصر details للقائمة.
   1) جلب مسبق للصفحة عند المرور على رابطها أو لمسه (Speculation Rules).
   2) سحب الدرج للإغلاق باللمس في اتجاه فتحه.
   3) فتح القائمة الرئيسية بلوحة المفاتيح حين يكون فتحها بالمرور. */
(function () {
  'use strict';
  if (window.sedrNav) return;
  window.sedrNav = true;

  /* ---------- 1) الجلب المسبق ---------- */
  /* جلب بلا تنفيذ (prefetch لا prerender): لا يشغّل سكربتات الصفحة فلا يسجّل زيارة ولا حدث قياس.
     تُستثنى السلة والدفع والحساب والبحث وكل رابط فيه استعلام. */
  function speculate() {
    try {
      if (!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
      /* إن أضافت المنصة أو تطبيق قواعد جلب للصفحات فلا نكرّرها. القواعد الفارغة {} لا تُحسب */
      var others = document.querySelectorAll('script[type="speculationrules"]');
      for (var i = 0; i < others.length; i++) {
        try {
          var r = JSON.parse(others[i].textContent || '{}');
          if ((r.prefetch && r.prefetch.length) || (r.prerender && r.prerender.length)) return;
        } catch (e) {}
      }
      var c = navigator.connection;
      if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.dataset.sedrNav = '';
      s.textContent = JSON.stringify({
        prefetch: [{
          source: 'document',
          where: {
            and: [
              { href_matches: '/*' },
              { not: { href_matches: ['/cart*', '/*/cart*', '/checkout*', '/checkouts/*', '/account*', '/*/account*',
                '/search*', '/*/search*', '/discount/*', '/services/*', '/apps/*', '/tools/*', '/cdn/*', '/*\\?*'] } },
              { not: { selector_matches: '[target="_blank"], [download], [rel~="nofollow"], [rel~="external"]' } }
            ]
          },
          eagerness: 'moderate'
        }]
      });
      document.head.appendChild(s);
    } catch (e) {}
  }

  /* ---------- 2) سحب الدرج للإغلاق ---------- */
  /* الدرج يتبع الإصبع، وعند الإفلات يكمل خروجه بسرعة السحب. حركة إغلاق القالب (قصّ بطيء البداية، 0.55 ث)
     تصلح للزر لا للسحب، فننهيها فور خروج الدرج حتى لا تبقى الصفحة محجوبة بعده. */
  var CLOSE_PX = 72;       /* مسافة تكفي للإغلاق */
  var CLOSE_V = 0.45;      /* أو سرعة (بكسل/م.ث) مع مسافة قصيرة */
  var SLOP = 8;            /* قبلها لا يُحسم الاتجاه */
  var EASE = 'cubic-bezier(.2,.7,.3,1)';
  var drag = null;
  var kb = null;           /* لمسة قد تصير تمريرًا يُنزل لوحة المفاتيح */
  var SHEET = window.matchMedia('screen and (max-width: 999px)');
  var bound = typeof WeakSet === 'function' ? new WeakSet() : null;

  /* ومع الدرج نافذة القالب المنبثقة (x-popover)، كمنتقي اللغة والدولة: هي دون 1000 بكسل ورقة سفلية مثله، ولا جهة فتح لها */
  function isDrawerEl(el) {
    return el && el.shadowRoot && typeof el.hide === 'function' && (typeof el.openFrom === 'string' || el.classList.contains('popover'));
  }

  /* مستمع الحركة غير السلبي على الدرج نفسه لا على المستند، فلا ينتظره تمرير الصفحة */
  function bind(d) {
    if (!bound || bound.has(d)) return;
    bound.add(d);
    d.addEventListener('touchmove', onMove, { passive: false, capture: true });
  }

  /* اتجاه الإغلاق: محور وإشارة بحسب جهة الفتح واتجاه الصفحة */
  function closeAxis(d) {
    var from = d.openFrom, rtl = document.dir === 'rtl';
    if (typeof from !== 'string') return SHEET.matches ? { y: 1 } : null;
    if (from === 'bottom') return { y: 1 };
    if (from === 'top') return { y: -1 };
    if (from === 'left') return { x: rtl ? 1 : -1 };
    if (from === 'right') return { x: rtl ? -1 : 1 };
    return null;
  }

  /* هل بين نقطة اللمس والدرج عنصر يتمرّر في اتجاه السحب؟ إن وُجد فالسحب تمرير لا إغلاق */
  function scrollsInside(path, d, ax) {
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n === d) return false;
      if (!(n instanceof Element)) continue;
      if (n.matches('input[type="range"], [data-sedr-noswipe]')) return true;
      var cs = getComputedStyle(n);
      if (ax.y) {
        if (/(auto|scroll)/.test(cs.overflowY) && n.scrollHeight > n.clientHeight + 1) {
          if (ax.y > 0 ? n.scrollTop > 0 : n.scrollTop + n.clientHeight < n.scrollHeight - 1) return true;
        }
      } else if (/(auto|scroll)/.test(cs.overflowX) && n.scrollWidth > n.clientWidth + 1) {
        return true;
      }
    }
    return false;
  }

  function tf(g, v) {
    v = v * (g.ax.y || g.ax.x);
    return g.ax.y ? 'translate3d(0,' + v + 'px,0)' : 'translate3d(' + v + 'px,0,0)';
  }

  function paint() {
    var g = drag;
    if (!g) return;
    g.raf = 0;
    g.content.style.transform = tf(g, g.dist);
    if (g.knob) g.knob.style.transform = tf(g, g.dist);
    if (g.overlay) g.overlay.style.opacity = String(1 - 0.7 * Math.min(1, g.dist / g.size));
  }

  function onStart(e) {
    /* لمسة وحيدة جديدة وسحب سابق لم يُختم: عنصره أُزيل تحت الإصبع فلم تصل نهاية لمسته */
    if (drag && e.touches.length === 1) { var old = drag; drag = null; if (old.raf) cancelAnimationFrame(old.raf); if (old.on) clear(old, []); }
    if (drag || e.touches.length !== 1) return;
    var path = e.composedPath(), d = null;
    for (var i = 0; i < path.length; i++) if (isDrawerEl(path[i])) { d = path[i]; break; }
    if (!d || !d.hasAttribute('open')) return;
    bind(d);
    /* للأدراج وحدها: منتقي الدولة يعيد ترتيب نفسه عند نزول اللوحة، فيقفز تحت الإصبع */
    kb = typeof d.openFrom !== 'string' || (path[0] instanceof Element && path[0].matches('input, textarea')) ? null : { d: d, id: e.touches[0].identifier, x: e.touches[0].clientX, y: e.touches[0].clientY };
    var content = d.shadowRoot.querySelector('[part="content"]');
    if (!content || path.indexOf(content) === -1) return;
    var ax = closeAxis(d);
    if (!ax || scrollsInside(path, d, ax)) return;
    var t = e.touches[0];
    /* زر الإغلاق الذي فوق الورقة المنبثقة ينزل معها */
    var knob = typeof d.openFrom === 'string' ? null : d.shadowRoot.querySelector('[part="outside-close-button"]');
    drag = { d: d, content: content, overlay: d.shadowRoot.querySelector('[part="overlay"]'), ax: ax, id: t.identifier,
      knob: knob && knob.getClientRects().length ? knob : null,   /* يُخفى من 700 بكسل ومع لوحة المفاتيح */
      x: t.clientX, y: t.clientY, on: false, base: 0, dist: 0, size: 1, raf: 0, s: [] };
  }

  function find(e) {
    var list = e.changedTouches;
    for (var i = 0; i < list.length; i++) if (list[i].identifier === drag.id) return list[i];
    return null;
  }

  function onMove(e) {
    var g = drag;
    /* تمرير نتائج البحث يُنزل لوحة المفاتيح حتى لا تحجبها. لحقل البحث وحده، فلا يُحفظ بذلك حقل كمية أو خصم */
    if (kb && e.touches.length === 1 && e.touches[0].identifier === kb.id) {
      var move = Math.abs(e.touches[0].clientY - kb.y), field = document.activeElement;
      if (move > 12 && move > Math.abs(e.touches[0].clientX - kb.x)) {
        if (field && kb.d.contains(field) && field.matches('input[type="search"]')) field.blur();
        kb = null;
      }
    }
    if (!g) return;
    var t = find(e);
    if (!t) return;
    var dx = t.clientX - g.x, dy = t.clientY - g.y;
    var along = g.ax.y ? dy * g.ax.y : dx * g.ax.x;
    var across = g.ax.y ? Math.abs(dx) : Math.abs(dy);
    if (!g.on) {
      /* السحب في اتجاه الإغلاق يُحجز من أول حركة، قبل حسم الاتجاه: إن تُرك للمتصفح بدأ تمريره (ارتداد القائمة في iOS) ولم يعد يُلغى، فيتحركان معًا */
      if (along > 0 && (g.ax.y || across <= along) && e.cancelable) e.preventDefault();
      if (Math.abs(along) < SLOP && across < SLOP) return;
      if (along <= 0 || across > along) { drag = null; return; }
      g.on = true;
      g.base = along;   /* تبدأ الحركة من موضع الإصبع الحالي بلا قفزة */
      var r = g.content.getBoundingClientRect();
      g.size = Math.max(1, (g.ax.y ? r.height : r.width) + 24);
      g.content.style.transition = 'none';
      g.content.style.willChange = 'transform';
      if (g.knob) { g.size += Math.max(0, r.top - g.knob.getBoundingClientRect().top); g.knob.style.transition = 'none'; g.knob.style.willChange = 'transform'; }
      if (g.overlay) { g.overlay.style.transition = 'none'; g.overlay.style.willChange = 'opacity'; }
    }
    if (e.cancelable) e.preventDefault();
    g.dist = Math.max(0, along - g.base);
    g.s.push(g.dist, e.timeStamp);
    if (g.s.length > 12) g.s.splice(0, 2);
    if (!g.raf) g.raf = requestAnimationFrame(paint);
  }

  /* سرعة آخر 100 م.ث من السحب، لا متوسط الحركة كلها. تُقاس إلى آخر حركة لا إلى رفع الإصبع، فلا تُضعفها المهلة بينهما، وإن طالت المهلة فالإصبع توقف */
  function velocity(g, now) {
    var n = g.s.length, last = n ? g.s[n - 1] : 0;
    if (!n || now - last > 80) return 0;
    for (var i = 0; i < n - 2; i += 2) {
      if (last - g.s[i + 1] <= 100) return (g.dist - g.s[i]) / Math.max(1, last - g.s[i + 1]);
    }
    return 0;
  }

  function clear(g, anims) {
    for (var i = 0; i < anims.length; i++) { try { anims[i].cancel(); } catch (e) {} }
    g.content.style.transition = ''; g.content.style.transform = ''; g.content.style.willChange = '';
    if (g.knob) { g.knob.style.transition = ''; g.knob.style.transform = ''; g.knob.style.willChange = ''; }
    if (g.overlay) { g.overlay.style.transition = ''; g.overlay.style.opacity = ''; g.overlay.style.willChange = ''; }
  }

  function run(g, to, ms) {
    var a = [], o = { duration: ms, easing: EASE, fill: 'forwards' };
    if (!g.content.animate) return a;
    a.push(g.content.animate([{ transform: tf(g, g.dist) }, { transform: tf(g, to) }], o));
    if (g.knob) a.push(g.knob.animate([{ transform: tf(g, g.dist) }, { transform: tf(g, to) }], o));
    if (g.overlay) {
      var from = 1 - 0.7 * Math.min(1, g.dist / g.size);
      a.push(g.overlay.animate([{ opacity: from }, { opacity: to ? 0 : 1 }], o));
    }
    return a;
  }

  /* ينهي حركات القالب الجارية على الدرج (غير حركاتنا) */
  function finishTheme(g, mine) {
    var els = [g.d, g.content].concat([].slice.call(g.content.children), [].slice.call(g.d.shadowRoot.querySelectorAll('[part]')));
    for (var i = 0; i < els.length; i++) {
      var list = els[i].getAnimations ? els[i].getAnimations() : [];
      for (var k = 0; k < list.length; k++) {
        if (mine.indexOf(list[k]) === -1) { try { list[k].finish(); } catch (e) {} }
      }
    }
  }

  function onEnd(e) {
    var g = drag;
    kb = null;
    if (!g) return;
    if (e.type !== 'touchcancel' && !find(e)) return;
    drag = null;
    if (g.raf) cancelAnimationFrame(g.raf);
    if (!g.on) return;
    var v = velocity(g, e.timeStamp);
    var close = e.type !== 'touchcancel' && v > -0.15 && (g.dist > CLOSE_PX || (g.dist > 24 && v > CLOSE_V));
    if (!close) {
      var back = run(g, 0, 280);
      if (back.length) back[0].onfinish = function () { clear(g, back); }; else clear(g, back);
      return;
    }
    var left = g.size - g.dist;
    var ms = Math.round(Math.min(400, Math.max(260, left / Math.max(v, 0.9))));
    var mine = run(g, g.size, ms);
    var done = g.d.hide();
    var reset = function () { clear(g, mine); };
    if (done && done.then) done.then(reset, reset); else reset();
    setTimeout(function () { finishTheme(g, mine); }, ms);
  }

  function touch() {
    if (!('ontouchstart' in window)) return;
    document.addEventListener('touchstart', onStart, { passive: true, capture: true });
    document.addEventListener('touchend', onEnd, { passive: true, capture: true });
    document.addEventListener('touchcancel', onEnd, { passive: true, capture: true });
    /* الأدراج الموجودة تُربط مسبقًا، وما يُضاف لاحقًا يُربط عند أول لمسة فيه */
    var all = function () { [].forEach.call(document.querySelectorAll('.drawer, .popover'), function (d) { if (isDrawerEl(d)) bind(d); }); };
    all();
    window.addEventListener('load', all);
  }

  /* ---------- 3) القائمة الرئيسية بلوحة المفاتيح ---------- */
  /* حين يكون الفتح بالمرور، Enter على العنوان يذهب إلى رابطه ولا يفتح القائمة،
     فلا يصل مستعمل لوحة المفاتيح إلى روابطها. السهم لأسفل والمسافة يفتحانها وينقلان التركيز إلى أول رابط. */
  function keyboard() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== ' ') return;
      var sum = e.target instanceof Element && e.target.closest('details[trigger="hover"] > summary');
      if (!sum) return;
      var det = sum.parentElement;
      e.preventDefault();
      det.open = true;
      requestAnimationFrame(function () {
        var first = det.querySelector(':scope > :not(summary) a[href], :scope > :not(summary) button:not([disabled])');
        if (first) first.focus();
      });
    });
  }

  speculate();
  touch();
  keyboard();
})();
